import {
  TOGGLE_UNIFY_TEXT,
  UPDATE_FONT,
  SET_LATEST_FONT,
  UPDATE_FONT_SIZE,
  SET_LATEST_FONT_SIZE,
} from "../actions/index";

const initialState = {
  unifyText: false,
  latestFont: null,
  latestFontSize: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_UNIFY_TEXT:
      return {
        ...state,
        unifyText: action.payload,
      };

    case UPDATE_FONT:
    case SET_LATEST_FONT:
      return {
        ...state,
        latestFont: {
          id: action.payload.font.id,
          name: action.payload.font.name,
          thumbnail: action.payload.font.thumbnail,
        },
      };

    case UPDATE_FONT_SIZE:
    case SET_LATEST_FONT_SIZE:
      return {
        ...state,
        latestFontSize: action.payload.value.trim(),
      };

    default:
      return state;
  }
}
